export default () => window !== window.parent;
